//1. Initialization\
import Offcanvas from 'bootstrap/js/dist/offcanvas';

//2. Event Area
let lastScrollTop = 0;

export function initNavigation() {
    window.addEventListener('scroll', stickyNav);
    burgerMenu();
}

function stickyNav(){
    const navHeader = document.querySelector('.navbar-custom');
    let currentScrollPos = window.scrollY;
    setTimeout(function(){
        if(currentScrollPos<=0){
            navHeader.classList.remove('hide');
            navHeader.classList.remove('show');
        }
        else if(currentScrollPos > lastScrollTop){
            navHeader.classList.add('hide');
            navHeader.classList.remove('show');
        } else {
            navHeader.classList.add('show');
            navHeader.classList.remove('hide');
        }
        lastScrollTop = currentScrollPos;
    }, 100);
}


export function burgerMenu(){
    const navbarOffcanvasElm = document.getElementById('offcanvasNavbar')
    const bsOffcanvas = new Offcanvas('#offcanvasNavbar')
    let isClosed = false;
    let burgerMenu = document.querySelector("#hamburger")
    let btnToggler=document.querySelector('.navbar-custom__toggler');


    btnToggler.addEventListener('click', (event)=>{  
        event.preventDefault();
        if (isClosed== true) {
            burgerMenu.classList.remove("open");
            burgerMenu.classList.add("closed");
            isClosed  = false;
            bsOffcanvas.hide();
        } else {
            burgerMenu.classList.remove("closed");
            burgerMenu.classList.add("open");
            isClosed = true;
            bsOffcanvas.show();
        }
    });

    navbarOffcanvasElm.addEventListener('hidden.bs.offcanvas', event => {
        burgerMenu.classList.remove("open");
        burgerMenu.classList.add("closed");
        isClosed  = false;
    })
}